import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { dateHelpers } from "../../app/helpers";
import { StockAnnouncementsFilter, StockMarketState } from "./stock-market.types";
import { stockMarketApi } from "./stock-market.api";
import { RootState } from "../../app/store";
import { getCachedDateRange } from "../../components/SmartDateRangeSelector";
import { NotificationType, showNotificationBase } from "../../app/notification-service";

export const DATE_FILETER_ID = "StockMarketAnnouncementsFilter";
const dateRange = getCachedDateRange(DATE_FILETER_ID);

const initialState: StockMarketState = {
    announcements: [],
    filter: {
        from: dateRange?.from || dateHelpers.toIsoString(new Date()),
        to: dateRange?.to || dateHelpers.toIsoString(new Date()),
        announcementCategories: "",
    },
};

export const fetchStockMarketAnnouncementsAsync = createAsyncThunk(
    "stockMarket/fetchAnnouncements",
    async (filter: StockAnnouncementsFilter, { dispatch, rejectWithValue }) => {
        try {
            const data = await stockMarketApi.getAnnouncements(filter);
            return data;
        } catch (e: any) {
            const errorMsg = e.response?.data?.message || e.message || "Unknown error";
            showNotificationBase(dispatch, NotificationType.error, errorMsg);
            return rejectWithValue(errorMsg);
        }
    }
);

export const stockMarketSlice = createSlice({
    name: "stockMarket",
    initialState,
    reducers: {
        setAnnouncements(state, action) {
            state.announcements = action.payload;
        },
        setAnnouncementsFilter(state, action: PayloadAction<any>) {
            state.filter = { ...state.filter, ...action.payload };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStockMarketAnnouncementsAsync.fulfilled, (state, action) => {
                state.announcements = action.payload;
                state.announcementsLoading = false;
            })
            .addCase(fetchStockMarketAnnouncementsAsync.pending, (state) => {
                state.announcementsLoading = true;
            })
            .addCase(fetchStockMarketAnnouncementsAsync.rejected, (state) => {
                state.announcementsLoading = false;
            });
    },
});

export const { setAnnouncements, setAnnouncementsFilter } = stockMarketSlice.actions;

export default stockMarketSlice.reducer;

export const stockMarketAnnouncementsFilterSelector = (state: RootState) => state.stockMarket.filter;
export const stockMarketAnnouncementsSelector = (state: RootState) => state.stockMarket.announcements;
export const stockMarketAnnouncementsLoadingSelector = (state: RootState) => state.stockMarket.announcementsLoading;
